import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row  } from 'antd';
import { Link } from 'react-router-dom';
import { Modal, Box } from '@mui/material';
import {  map } from "lodash"
import styled from 'styled-components';
import VideoLinks from './../containers/videoLinks';
import { closeModal ,  videoLink } from "utils/assets/images"
import { useHowToVideos } from 'store/howToVideos/selectors';
import { useDispatch } from 'react-redux';
import { handleListHowToVideos } from "store/howToVideos/thunks";
import COLOR from "utils/constants/color";
import { getFireBaseUrl } from 'utils/config/reference';
import { EmptyImagePlaceholder } from 'components/EmptyPlaceholderLesson';
import SpinLoader from 'components/Loader/SpinLoader';
import SentryWrap from 'components/Sentry';

const VideoModal = styled.video`
    //  max-width:60vw; 
    width:100%;
`;
const style = {};

export default function LearnScreen() {
    const howToVideos = useHowToVideos()
    const dispatch = useDispatch()
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [videoModalInfo, setVideoModalInfo] = React.useState({
        open: false,
        video: '',
        poster: ''
    });
    const handleOpen = (item) => setVideoModalInfo({
        open: true,
        video: item.video,
        poster: item.poster
    });
    const handleClose = () => setVideoModalInfo({
        open: false,
        video: '',
        poster: ''
    });
    useEffect(()=>{
        fetchVideosData();
    }, [])

    const fetchVideosData = async () => {
      try {
        if (howToVideos?.length === 0) {
          setLoading(true)
          await dispatch(handleListHowToVideos())
        }
      } catch (error) {
        console.error("Error fetching videos:", error)
      } finally {
        setLoading(false)
      }
    }
    

    const filterVideos = useMemo(() => {
      if (searchQuery?.length > 0) {
        const filterData = howToVideos?.filter((item) => {
          return item?.title
            ?.toLowerCase()
            ?.includes(searchQuery?.toLowerCase());
        });
        return filterData;
      } else {
        return howToVideos;
      }
    }, [searchQuery, howToVideos]);

    return (
        <SentryWrap>
            <SpinLoader dataloader={loading} />
            <Modal open={videoModalInfo.open} onClose={handleClose} className="modelCntnt">
                <Box sx={style} className="modelCntntIner modalVideoPlay">
                    <div className="lernModalBg">
                        <div className="modelDtl">
                            <div className="closeModelInfo closeVideoModal" onClick={handleClose}>
                                <img style={{height: "30px", zIndex: 50}} src={closeModal} onClick={handleClose}   />
                            </div>
                            <VideoModal className='videoShadow' controls autoPlay   controlsList="nodownload"  src={videoModalInfo.video} poster={videoModalInfo.poster} />
                        </div>
                    </div>
                </Box>
        </Modal>
        <Row className="searchHowToVideo">
          <CategoryMenu
                className={`search-bar-resource`}
                style={{ display: "flex", border: "1px solid #ffffff", marginBottom: "24px", paddingRight: 0, width: "100%" }}
            >
                              <SearchInput
                                style={{ width: "100%" }}
                                className="search-input"
                                type={"text"}
                                placeholder="SEARCH"
                                value={searchQuery}
                                onChange={(e) => { setSearchQuery(e.target.value) }}
                              />
                              <div className="dropdown-resource-arrow-container">
                                
                                  <img
                                    src={getFireBaseUrl("search-icon-placeholder.svg")}
                                    alt=""
                                  />
                              </div>
          </CategoryMenu>
        </Row>
            <Row className="videoContentUpr" gutter={[25, 0]}>
                <Col xs={24} sm={24} md={18}>
                {filterVideos?.length > 0 &&  (
                   <div className="learnContent">
                   <Row gutter={[25, 0]} className="learnDetail">
                       {map(filterVideos, item => (<Col key={item.id} xs={12} sm={12} md={8} className="cstmLrnRow" onClick={() => handleOpen(item)}>
                           <div className="ShowDetailBnr">
                               <img src={item.poster} />
                               <Link style={{ cursor:"pointer"}} className="ShowDetail"><img src={videoLink} /></Link>
                           </div>
                           <div className="learnCntLink learnVideoSubTitle"><a>{item.title}</a></div>
                       </Col>))}
                   </Row>
                 </div>
                )}
         
                </Col>
                {!loading && filterVideos?.length === 0 &&  <EmptyImagePlaceholder noData='No hay videos' isFullTitle={true} />}

                {filterVideos?.length > 0 && (
                <Col xs={24} sm={24} md={6} className="searchWeb">
                 <VideoLinks Items={filterVideos} onClick={handleOpen} />
                </Col>
                )}


            </Row>
        </SentryWrap>
    );
}

const SearchInput = styled.input`
  height: 100%;
  color: black;
  border: none;
  background: transparent;
  outline: none;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${COLOR.black200};
  }
  ::focus {
    outline: none;
  }
  @media only screen and (max-width: 360px) {
    width: 92px;
  }
`;


const CategoryMenu = styled.div`
  background-color: white;
  border-radius: 30px;
  color: Black !important;
  width: 541px !important;
  height: 42px; 
  display: flex;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 1px solid #0B2B3A !important;
  padding-left: 15px;
  justify-content: space-between;
  margin-left:1px !important; 
  @media screen and (max-width: 1200px) {
    font-size: 14px;
  }
  @media screen and (max-width: 767px) {
    width:100% !important;
    margin-inline:1px !important; 
  }
`;